export default __webpack_public_path__ + "static/media/ge.583afaa6.svg";